export const transformQuizardWinnerLeaderboardData = (data) => {
    return {
      global_rank:data.global_rank,
      User_Rank: data.jsSortRank,
      score:data.right_count,
      msisdn: data.msisdn || "",
      time_taken: data.time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformQuizardWinnerLeaderboardDataArray = (dataArray,numberOfWinner=null) => {
    // After sorting, add jsSortRank to each object
    let jsSortRank = 1;
    if (Array.isArray(dataArray)) {
      dataArray = dataArray.slice().sort((a, b) => {
        const rankA = a.global_rank !== undefined ? a.global_rank : Infinity;
        const rankB = b.global_rank !== undefined ? b.global_rank : Infinity;
        return rankA - rankB;
      });
      dataArray.forEach(obj => {
        obj.jsSortRank = jsSortRank++;
      });
    }
    if (!Array.isArray(dataArray)) {
      return [];
    }
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformQuizardWinnerLeaderboardData(data));
    }
    return dataArray.map(data => transformQuizardWinnerLeaderboardData(data));
  };

  export const transformWinnerlistData = (data) => {
    return {
      global_rank:data.serial_no,
      User_Rank: data.jsSortRank,
      score:data.right_count,
      msisdn: data.msisdn || "",
      time_taken: data.time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformWinnerlistDataArray = (dataArray,numberOfWinner=null) => {
    // After sorting, add jsSortRank to each object
    let jsSortRank = 1;
    if (Array.isArray(dataArray)) {
      dataArray.forEach(obj => {
        obj.jsSortRank = jsSortRank++;
      });
    }
    if (!Array.isArray(dataArray)) {
      return [];
    }
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformWinnerlistData(data));
    }
    return dataArray.map(data => transformWinnerlistData(data));
  };


  export const transformDailyWinnerNData = (data) => {
    return {
      global_rank: data.serial_no,
      User_Rank: data.jsSortRank,
      score: data.right_count,
      msisdn: data.msisdn || "",
      time_taken: data.time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformDailyWinnerNDataArray = (dataArray, numberOfWinner = null) => {
    // API returns { message: "No records found" } (an object) when empty
    if (!Array.isArray(dataArray)) {
      return [];
    }
    // Sort by serial_no ascending to show proper serial, then assign display rank
    let jsSortRank = 1;
    dataArray = dataArray.slice().sort((a, b) => {
      const serialA = a.serial_no !== undefined ? a.serial_no : Infinity;
      const serialB = b.serial_no !== undefined ? b.serial_no : Infinity;
      return serialA - serialB;
    });
    dataArray.forEach(obj => {
      obj.jsSortRank = jsSortRank++;
    });
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformDailyWinnerNData(data));
    }
    return dataArray.map(data => transformDailyWinnerNData(data));
  };


  export const transformWinnerlistDataForBLQuizard = (data) => {
    return {
      global_rank:data.rank,
      User_Rank: data.jsSortRank,
      score:data.total_right_count,
      msisdn: data.msisdn || "",
      time_taken: data.total_time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformWinnerlistDataForBLQuizardArray = (dataArray,numberOfWinner=null) => {
    // After sorting, add jsSortRank to each object
    let jsSortRank = 1;
    if (Array.isArray(dataArray)) {
      dataArray.forEach(obj => {
        obj.jsSortRank = jsSortRank++;
      });
    }
    if (!Array.isArray(dataArray)) {
      return [];
    }
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformWinnerlistDataForBLQuizard(data));
    }
    return dataArray.map(data => transformWinnerlistDataForBLQuizard(data));
  };


  export const transformTournamentWinnerData = (data) => {
    return {
      global_rank: data.global_rank,
      User_Rank: data.jsSortRank,
      score: data.right_count,
      msisdn: data.msisdn || "",
      time_taken: data.time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformTournamentWinnerDataArray = (dataArray, numberOfWinner = null) => {
    // API returns a non-array (e.g. { message: "No records found" }) when empty
    if (!Array.isArray(dataArray)) {
      return [];
    }
    // Sort by global_rank ascending, then assign sequential display rank
    let jsSortRank = 1;
    dataArray = dataArray.slice().sort((a, b) => {
      const rankA = a.global_rank !== undefined ? a.global_rank : Infinity;
      const rankB = b.global_rank !== undefined ? b.global_rank : Infinity;
      return rankA - rankB;
    });
    dataArray.forEach(obj => {
      obj.jsSortRank = jsSortRank++;
    });
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformTournamentWinnerData(data));
    }
    return dataArray.map(data => transformTournamentWinnerData(data));
  };